import React, { useState, useEffect } from "react";
import Buscar from "../../components/ProcesosDeCalificacion/Buscar";
import DescargarDocumentos from "../../components/ProcesosDeCalificacion/DescargarDocumentos";

import { Link } from "react-router-dom";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { Tabla } from "../../components/Otros/Tabla";
import { PlaceholderTabla } from "../../components/Otros/Placeholder";
import { verProceso } from "../../utils/Datos";

const Gestion = () => {
  let searchInit = {
    searchYear: "",
    searchName: "",
    status: false,
  };

  const [search, setSearch] = useState(searchInit);
  const [cargando, setCargando] = useState(false);
  const [process, setProcess] = useState([]);

  useEffect(() => {
    if (search.status) {
      setCargando(true);
      var data = {};
      data.searchName = search.searchName;
      data.searchYear = search.searchYear;

      verProceso(data).then((response) => {
        console.log(response.json);
        setCargando(false);
        if (response !== null && response != []) {
          setProcess(response);
        } else {
          setProcess([]);
        }
      });
    }
  }, [search]);

  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: "",
      title: "Buscar Proceso de Calificación",
      bullet: "false",
    },
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar title="BUSCAR PROCESOS" enlaces={toolbarEnlaces} />
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <Buscar search={search} setSearch={setSearch} />

            <div className="col-xl-12">
              <div className="card">
                <div className="card-header mt-6">
                  <div className="card-title flex-column">
                    <h2 className="mb-1">
                      RESULTADOS DE BÚSQUEDA / PROCESOS ACTIVOS
                    </h2>
                  </div>
                  <div className="card-toolbar">
                    <Link
                      to={"crearProceso"}
                      className="btn btn-light-success btn-sm"
                    >
                       Crear Proceso
                    </Link>
                  </div>
                </div>

                <div className="card-body">
                  {cargando ? (
                    <PlaceholderTabla></PlaceholderTabla>
                  ) : (
                    <Tabla
                      columnas={[
                        {
                          name: "Año",
                          selector: (row) => row.yearProcess,
                          sortable: true,
                          maxWidth: "100px",
                        },
                        {
                          name: "Nombre",
                          selector: (row) => (
                            <span style={{ whiteSpace: "normal" }}>
                              {row.name}
                            </span>
                          ),
                          sortable: true,
                          width: "20%",
                        },
                       
                        {
                          name: "Ver / Editar",
                          selector: (row) => (
                            <Link
                              className="btn btn-sm btn-secondary"
                              to={`/editarProceso/${row.id_process}`}
                            >
                              <i className="fas fa-pencil-alt mr-2"></i>Ver /
                              Editar
                            </Link>
                          ),
                          sortable: false,
                          minWidth: "150px",
                        },
                        {
                          name: "Participantes",
                          selector: (row) => (
                            <Link
                              className="btn btn-sm btn-secondary"
                              to={`/participacionProceso/${row.id_process}`}
                            >
                              <i className="fas fa-eye mr-2"></i>Ver
                            </Link>
                          ),
                          sortable: false,
                          minWidth: "150px",
                        },
                       
                        {
                          name: "Notificaciones",
                          selector: (row) => (
                            <Link
                              className="btn btn-sm btn-secondary"
                              to={`/procesoConformidad?idProcess=${row.id_process}`}
                            >
                              <i className="fas fa-bell mr-2"></i>Notificaciones
                            </Link>
                          ),
                          sortable: false,
                          minWidth: "150px",
                        },
                        
                        {
                          name: "Descargar DOC",
                          selector: (row) => (
                            <DescargarDocumentos
                              id_process={row.id_process}
                              name={row.name}
                              yearProcess={row.yearProcess}
                            />
                          ),
                          sortable: false,
                          minWidth: "150px",
                        } ,
                        {
                          name: "Reportes",
                          selector: (row) => ( 
                            <Link
                              className="btn btn-sm btn-info"
                              to={`/reporteProceso/${row.id_process}`}
                            >
                              <i className="fas fa-file mr-2"></i>Reportes
                            </Link>
                          ),
                          sortable: false,
                          minWidth: "150px",
                        }/*
                        { 
                          name: "Ver",
                          selector: (row) => (
                            <a
                              href="#/"
                              className="btn btn-sm btn-secondary"
                            >
                              <i className="fas fa-eye mr-2"></i>Ver
                            </a>
                          ),
                          sortable: false,
                          minWidth: "150px", 
                        }*/,
                      ]}
                      datos={process}
                    ></Tabla>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gestion;
